<main>
  <div class="row page-title-block d-flex">
    <div class="col d-flex align-items-center mb-2">
      <h1 class="page-title">Issues Dashboard</h1>
    </div>
    <div class="row">
      @if (!hasAccesOnlyToProductLinks()) {
        <div class="d-flex flex-column g-4 tables-container">
          <app-process-issues-table class="table-item"></app-process-issues-table>
          <app-open-tickets-table class="table-item"></app-open-tickets-table>
        </div>
      } @else {
        <p><b>No data found.</b></p>
      }
    </div>
  </div>
</main>
